/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
  'cloud-drizzle': {
    width: 32,
    height: 32,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M8 19v2M8 13v2M16 19v2M16 13v2M12 21v2M12 15v2M20 16.58A5 5 0 0018 7h-1.26A8 8 0 104 15.25"/>',
  },
});
